import { ActionMap } from "library/ActionMap";

export type State = {
  loading: boolean;
  Page: PageType;
  otpResendUrl?: string;
  otpVerifyUrl?: string;
  maskedMobileNumber?: string;
};

export enum PageType {
  LOADING = "LOADING",
  OTP_FORM = "OTP_FORM",
  ERROR = "ERROR",
  MAX_TRIES_REACHED = "MAX_TRIES_REACHED",
}

export enum ActionType {
  DATA_FETCHED_SUCCESSFULLY = "DATA_FETCHED_SUCCESSFULLY",
  MAX_TRIES_REACHED_ERROR = "MAX_TRIES_REACHED_ERROR",
  ERROR = "ERROR",
  OTP_Exceeded_Allowed_Limits = "OTP_Exceeded_Allowed_Limits",
}

type PayLoads = {
  [ActionType.DATA_FETCHED_SUCCESSFULLY]: {
    otpResendUrl: string;
    otpVerifyUrl: string;
    maskedMobileNumber: string;
  };
};

export type Actions = ActionMap<ActionType, PayLoads>;
